import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
// import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	async toggleShare() {
		if (this.props.activePage === 'boltPhotobooth') {
			window.firePowsterCustomEvent?.('photobooth-share', 'photobooth', '');
		}
		await super.toggleShare();
	}
}
